import React from "react";
import "components/Tribe/Friends/UserDetail/FriendNewsfeed/Reaction.css";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton"
import * as CONSTANT from "constants/text";
import FavoriteIcon from '@material-ui/icons/Favorite';

function AddReactionButton (props){

        return (
            <div className = "reaction_button">
                <RoundedButton
                    title = {CONSTANT.LIKE}
                    startIcon = {<FavoriteIcon style = {{fontSize: 20, color: "white"}} />}
                    textThemeClassName = "text_small text_white"
                    handleOnClick = {() => (props.onClick())}
                    buttonClassName = "background_light_med_grey"
                    float = "none"
                    borderRadius="6px"
                />
            </div>
        );
}

export default AddReactionButton;